module.exports = __webpack_public_path__ + "img/vivliopisw.9d5392d0.jpg";